import React, { useEffect, useState } from "react";
import "../css/MCQ.css";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { URL } from "../../../Redux/common/url";
import { allapiAction } from "../../../Redux/common/action";
const questionsm = [
  {
    q: "This is the Question 1",
    correct: "B",
    options: {
      A: "this is the option",
      B: "this is the option",
      C: "this is the option",
      D: "this is the option",
    },
  },
  {
    q: "This is the Question 2",
    correct: "C",
    options: {
      A: "option one",
      B: "option two",
      C: "option three",
      D: "option four",
    },
  },
];
const MCQ = () => {
  const [preview, setPreview] = useState(true);

  const dispatch = useDispatch();
  const router = useNavigate();
  const { id } = useParams();
  const [post, setpost] = useState({});
  const [reletedProduct, setreletedProduct] = useState([]);
  const [reletedProduct2, setreletedProduct2] = useState({});
  //   const [result, setresult] = useState([]);
  const [reletedProductbrand, setreletedProductbrand] = useState([]);
  const [questions, setquestions] = useState([]);
  const [shopDetails, setshopDetails] = useState([]);
  const [productImage, setproductImage] = useState([]);
  const [productColor, setproductColor] = useState("");
  const [productSize, setproductSize] = useState({});
  const [productSizeList, setproductSizeList] = useState([]);
  const recentProduct = reletedProduct ? reletedProduct : [];

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const [result, setresult] = useState([]);
  console.log(result);

  const hendleTosubmit = async () => {
    const response = await dispatch(
      allapiAction.submitResult({
        examId: id,

        rightAnswer: score,
      })
    );
    // proDetailsCon()
    router(-1);
  };

  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState("");

  console.log(questions);

  const current = questions[currentQuestion];
  const handleNext = () => {
    try {
      // result.push({
      //   question: questions[currentQuestion].question,
      //   answer: questions[currentQuestion].answer,
      //   selectedOption: selectedOption,
      // });
      setresult([
        ...result,
        {
          question: questions[currentQuestion].question,
          answer: questions[currentQuestion].answer,
          selectedOption: selectedOption,
        },
      ]);
      console.log(result);

      if (selectedOption === questions[currentQuestion].answer) {
        setScore(score + 1);
      }

      if (currentQuestion + 1 < questions.length) {
        setCurrentQuestion(currentQuestion + 1);
        setSelectedOption("");
      } else {
        setShowResult(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const proDetailsCon = async () => {
    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // var requestOptions = {
    //   method: "GET",
    //   headers: myHeaders,
    //   redirect: "follow",
    // };

    // const bgl = await fetch(
    //   URL.API_BASE_URL + `${URL.questionListuser}/${id}`,
    //   requestOptions
    // );
    var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const token = await localStorage.getItem("access_token");
        const config = {
          headers: {
            Authorization: "bearer " + token,
          },
        };
    
        const bgl = await fetch(
          URL.API_BASE_URL + `${URL.questionListuser}/${id}`,
          config
        );

    // const bg2 = await fetch(
    //   URL.API_BASE_URL + `${URL.productDetailsReleted}/${id}`,
    //   requestOptions
    // );
    // const bg3 = await fetch(
    //   URL.API_BASE_URL + `${URL.productDetailsReletedBrand}/${id}`,
    //   requestOptions
    // );
    // const bg4 = await fetch(
    //   URL.API_BASE_URL + `${URL.productShopDetails}/${id}`,
    //   requestOptions
    // );
    const events = await bgl.json();
    // const events2 = await bg2.json();
    // const events3 = await bg3.json();
    // const events4 = await bg4.json();
    const postData = events?.data;
    // const postData2 = events2?.data;
    // const postData3 = events3?.data;
    // const postData4 = events4?.data;

    setpost(postData?.lessionDetails);
    setreletedProduct2(postData?.examData);

    console?.log(postData?.getQuestion);

    const allQu = postData?.getQuestion || [];

    const allQuf = allQu?.map((data) => {
      return {
        ...data,
        correct: "B",
        options: {
          A: data?.option1,
          B: data?.option2,
          C: data?.option3,
          D: data?.option4,
        },
      };
    });

    // options
    // setquestions(postData?.getQuestion);
    setquestions(allQuf);
    // setreletedProduct(postData2);
    // setreletedProductbrand(postData3);
    // setshopDetails(postData4);
  };

  useEffect(() => {
    proDetailsCon();

    return () => {};
  }, [id]);

  if (!current) return null;

  const handleSelect = (key, value) => {
    console.log(key);
    console.log(value);

    // if (selected !== "") return;
    setSelected(key);
    setSelectedOption(value);
  };

  const optionStyle = (key) => ({
    background: "#000",
    border:
      selected === key
        ? key === current.correct
          ? "2px solid #28a745"
          : "2px solid #28a745"
        : "2px solid #00e5ff",
    boxShadow:
      selected === key
        ? key === current.correct
          ? "0 0 10px rgba(40,167,69,0.8)"
          : "0 0 10px rgba(220,53,69,0.8)"
        : "0 0 8px rgba(0,229,255,0.7)",
    padding: "12px",
    borderRadius: "10px",
    marginBottom: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: "#fff",
    width: "100%",
  });
  // const optionStyle = (key) => ({
  //   background: "#000",
  //   border:
  //     selected === key
  //       ? key === current.correct
  //         ? "2px solid #28a745"
  //         : "2px solid #dc3545"
  //       : "2px solid #00e5ff",
  //   boxShadow:
  //     selected === key
  //       ? key === current.correct
  //         ? "0 0 10px rgba(40,167,69,0.8)"
  //         : "0 0 10px rgba(220,53,69,0.8)"
  //       : "0 0 8px rgba(0,229,255,0.7)",
  //   padding: "12px",
  //   borderRadius: "10px",
  //   marginBottom: "12px",
  //   cursor: "pointer",
  //   display: "flex",
  //   alignItems: "center",
  //   color: "#fff",
  //   width: "100%",
  // });

  return (
    <div style={{ maxWidth: "500px", margin: "20px auto", color: "#fff" }}>
      {!showResult && (
        <div
          style={{
            background: "#000",
            border: "2px solid #00e5ff",
            boxShadow: "0 0 15px rgba(0,229,255,0.8)",
            borderRadius: "15px",
            padding: "16px",
          }}
        >
          {/* QUESTION */}
          <div
            style={{
              background: "#000",
              border: "2px solid #00e5ff",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <b>Q</b>
            <span style={{ margin: "0 8px" }}>|</span>
            <span>{current?.question}</span>
          </div>

          {/* OPTIONS */}
          {Object.entries(current.options).map(([key, value]) => (
            <div
              key={key}
              style={optionStyle(key)}
              onClick={() => handleSelect(key, value)}
            >
              <b>{key}</b>
              <span style={{ margin: "0 8px" }}>|</span>
              <span>{value}</span>
            </div>
          ))}

          {/* ANSWER */}
          {/* {selected !== "" && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              borderRadius: "10px",
              border:
                selected === current.correct
                  ? "2px solid #28a745"
                  : "2px solid #dc3545",
              textAlign: "center",
              color: selected === current.correct ? "#28a745" : "#dc3545",
            }}
          >
            {selected === current.correct ? (
              <b>✅ Correct Answer : {current.correct}</b>
            ) : (
              <b>
                ❌ Wrong Answer | Correct Answer :{" "}
                <span style={{ color: "#28a745" }}>{current.correct}</span>
              </b>
            )}
          </div>
        )} */}

          {/* NEXT / PREVIOUS */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
              gap: "10px",
            }}
          >
            {/* <button
            disabled={index === 0}
            onClick={() => {
              setIndex(index - 1);
              setSelected("");
            }}
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "25px",
              border: "2px solid #00e5ff",
              background: "#000",
              color: "#fff",
              opacity: index === 0 ? 0.4 : 1,
            }}
          >
            ⬅ Previous
          </button> */}

            {/* <button
            disabled={index === questionsm.length - 1}
            onClick={() => {
              setIndex(index + 1);
              setSelected("");
            }}
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "25px",
              border: "2px solid #00e5ff",
              background: "#000",
              color: "#fff",
              opacity: index === questionsm.length - 1 ? 0.4 : 1,
            }}
          >
            Next ➡
          </button> */}
            <button
              // disabled={index === questionsm.length - 1}
              onClick={() => {
                setIndex(index + 1);
                setSelected("");
                handleNext();
              }}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: "25px",
                border: "2px solid #00e5ff",
                background: "#000",
                color: "#fff",
                // opacity: index === questionsm.length - 1 ? 0.4 : 1,
              }}
            >
              {currentQuestion + 1 === questions?.length ? "Submit" : " Next ➡"}
            </button>
          </div>
        </div>
      )}

     

      {showResult && (
        <div
          style={{
            background: "#000",
            border: "2px solid #00e5ff",
            boxShadow: "0 0 15px rgba(0,229,255,0.8)",
            borderRadius: "15px",
            padding: "20px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "20px",
              color: "#00e5ff",
            }}
          >
            आपका परिणाम
          </h2>

          <div
            style={{
              background: "rgba(0, 229, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              marginBottom: "20px",
              border: "1px solid #00e5ff",
            }}
          >
            <p style={{ fontSize: "18px", margin: 0 }}>
              आपने <b>{questions.length}</b> में से{" "}
              <b style={{ color: "#28a745", fontSize: "22px" }}>{score}</b> सही
              उत्तर दिए हैं।
            </p>
          </div>

          {result && result.length > 0 && (
            <div style={{ marginTop: "20px", textAlign: "left" }}>
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "15px",
                  borderBottom: "1px solid #333",
                  pb: "5px",
                }}
              >
                विवरण (Review):
              </h3>
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  paddingRight: "10px",
                }}
              >
                {result.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "15px",
                      padding: "12px",
                      background: "#111",
                      borderRadius: "8px",
                      borderLeft:
                        item.selectedOption === item.answer
                          ? "4px solid #28a745"
                          : "4px solid #dc3545",
                    }}
                  >
                    <div style={{ marginBottom: "5px" }}>
                      <b style={{ color: "#00e5ff" }}>Q{index + 1}:</b>{" "}
                      {item.question}
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      <strong>आपका उत्तर:</strong>{" "}
                      <span
                        style={{
                          color:
                            item.selectedOption === item.answer
                              ? "#28a745"
                              : "#dc3545",
                          fontWeight: "bold",
                        }}
                      >
                        {item.selectedOption || "Not Answered"}
                      </span>
                    </div>
                    {item.selectedOption !== item.answer && (
                      <div style={{ fontSize: "14px", marginTop: "2px" }}>
                        <strong style={{ color: "#28a745" }}>सही उत्तर:</strong>{" "}
                        {item.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{ marginTop: "25px" }}>
            <button
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "25px",
                border: "2px solid #00e5ff",
                background: "#00e5ff",
                color: "#000",
                fontWeight: "bold",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0 0 10px rgba(0,229,255,0.5)",
                transition: "0.3s",
              }}
              onMouseOver={(e) =>
                (e.target.style.boxShadow = "0 0 20px rgba(0,229,255,0.9)")
              }
              onMouseOut={(e) =>
                (e.target.style.boxShadow = "0 0 10px rgba(0,229,255,0.5)")
              }
              onClick={hendleTosubmit}
            >
              Final Submit & Exit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MCQ;
